import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-61b7c0f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subscribe-details-wrap" }
const _hoisted_2 = { class: "step-item-content" }
const _hoisted_3 = { class: "service-page-title" }
const _hoisted_4 = { class: "pay-details el-card" }
const _hoisted_5 = { class: "box-header" }
const _hoisted_6 = { class: "header-left" }
const _hoisted_7 = { class: "box-body" }
const _hoisted_8 = {
  key: 0,
  class: "form-item",
  style: {"width":"100%"}
}
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "form-item" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = {
  class: "form-item",
  style: {"width":"100%"}
}
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "client-count" }
const _hoisted_15 = { class: "calculate-date" }
const _hoisted_16 = { class: "calculate-date" }
const _hoisted_17 = {
  class: "form-item",
  style: {"width":"100%"}
}
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "service-page-title" }
const _hoisted_20 = {
  key: 0,
  class: "step-footer"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_22 = { class: "footer-right" }
const _hoisted_23 = {
  key: 1,
  class: "step-footer"
}
const _hoisted_24 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepList = _resolveComponent("StepList")!
  const _component_RenewalService = _resolveComponent("RenewalService")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_CmTag = _resolveComponent("CmTag")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_FormulaDetail = _resolveComponent("FormulaDetail")!
  const _component_SubscribeDetailsTable = _resolveComponent("SubscribeDetailsTable")!
  const _component_ConfirmOrder = _resolveComponent("ConfirmOrder")!
  const _component_PayNative = _resolveComponent("PayNative")!
  const _component_OfficePay = _resolveComponent("OfficePay")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_OrderPrice = _resolveComponent("OrderPrice")!
  const _component_PayError = _resolveComponent("PayError")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_PayDetails = _resolveComponent("PayDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_StepList, {
      class: "cm-ui-mb15",
      "active-index": _ctx.currentStepIndex,
      steps: _ctx.stepDisplayList
    }, null, 8, ["active-index", "steps"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.stepList.includes(_ctx.STEP_RENEW))
        ? _withDirectives((_openBlock(), _createBlock(_component_RenewalService, {
            key: 0,
            onChangeSelect: _ctx.changeRenewalServiceSelect,
            onNavigateServiceSubscribe: _ctx.handleNavigateServiceSubscribe
          }, null, 8, ["onChangeSelect", "onNavigateServiceSubscribe"])), [
            [_vShow, _ctx.stepList[_ctx.currentStepIndex] === _ctx.STEP_RENEW]
          ])
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('subscribeDetails.payDetailsTitle')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.companyName), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.areaList.length > 1 && _ctx.currentArea)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('subscribeDetails.selectAreaLabel')), 1),
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.currentArea,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentArea) = $event)),
                    onChange: _ctx.updatePriceIds
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_radio, {
                          key: item,
                          label: item,
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.areaTypeLabel(item)) + _toDisplayString(_ctx.$t('subscribeDetails.areaZoneSuffix')), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('subscribeDetails.serviceYearsLabel')), 1),
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.cycleCount,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cycleCount) = $event)),
                onChange: _ctx.updatePriceIds
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceMergeListCycle, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_radio, {
                      key: item.cycle_count,
                      label: item.cycle_count,
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.CYCLE_DESC[item.cycle_count]) + _toDisplayString(_ctx.DateKindLabel[_ctx.orderInfo.date_kind]), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"]),
              (_ctx.serviceMergeListCycle.find(v => v.cycle_count === 3))
                ? (_openBlock(), _createBlock(_component_CmTag, {
                    key: 0,
                    style: {"padding":"0px 4px","border-radius":"4px"},
                    "bg-color": "#FAAD14",
                    color: "#fff"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscribeDetails.discount8')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('subscribeDetails.terminalQuotaLabel')), 1),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_popover, {
                  disabled: !_ctx.viewModel.priceData.before_calculate_date?.expire_time,
                  placement: "bottom",
                  width: "auto",
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      class: "cm-ui-mr5",
                      modelValue: _ctx.queryParams.purchase_count,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.queryParams.purchase_count) = $event)),
                      size: "small",
                      min: 10,
                      max: 9999,
                      precision: 0,
                      "controls-position": "right",
                      style: {"width":"100px"},
                      onChange: _ctx.updateCalcPrice
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('subscribeDetails.beforeRenew', { count: _ctx.viewModel.priceData.before_calculate_date?.count, date: _ctx.formatTimeStamp(_ctx.viewModel.priceData.before_calculate_date?.expire_time, 'YYYY-MM-DD') })), 1),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('subscribeDetails.afterRenew', { count: _ctx.viewModel.priceData.after_calculate_date?.count, date: _ctx.formatTimeStamp(_ctx.viewModel.priceData.after_calculate_date?.expire_time, 'YYYY-MM-DD') })), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createTextVNode(_toDisplayString(_ctx.$t('subscribeDetails.terminalSuffix')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('subscribeDetails.orderTotalLabel')), 1),
              (_ctx.viewModel.priceData.origin_price)
                ? (_openBlock(), _createBlock(_component_FormulaDetail, {
                    key: 0,
                    "price-data": _ctx.viewModel.priceData
                  }, null, 8, ["price-data"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.$t('subscribeDetails.subscribeDetailTitle')), 1),
        _createVNode(_component_SubscribeDetailsTable, { "service-merge": _ctx.serviceMergeList }, null, 8, ["service-merge"])
      ], 512), [
        [_vShow, _ctx.stepList[_ctx.currentStepIndex] === _ctx.STEP_OPTIONS]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_ConfirmOrder, {
          ref: "confirmOrderNode",
          "base-info": {
            date_kind: _ctx.orderInfo.date_kind,
            cycle_count: _ctx.cycleCount,
            purchase_count: _ctx.queryParams.purchase_count,
            current_price: _ctx.viewModel.priceData.current_price,
            group: _ctx.serviceMergeList.find(v => v.child_price?.length)?.title,
            services: _ctx.serviceMergeList.filter(v => !v.child_price?.length)?.map(v => v.title)
          },
          onConfirm: _ctx.handleConfirmOrder
        }, null, 8, ["base-info", "onConfirm"])
      ], 512), [
        [_vShow, _ctx.stepList[_ctx.currentStepIndex] === _ctx.STEP_CONFIRM]
      ]),
      (_ctx.stepList[_ctx.currentStepIndex] === _ctx.STEP_PAY)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.queryParams.pay_type === _ctx.PayType.online)
              ? (_openBlock(), _createBlock(_component_PayNative, {
                  key: 0,
                  visible: _ctx.queryParams.pay_type === _ctx.PayType.online,
                  "product-id": _ctx.payParams.product_id
                }, null, 8, ["visible", "product-id"]))
              : _createCommentVNode("", true),
            (_ctx.queryParams.pay_type === _ctx.PayType.office)
              ? (_openBlock(), _createBlock(_component_OfficePay, {
                  key: 1,
                  "product-id": _ctx.payParams.product_id,
                  onConfirm: _ctx.handleOfficePayConfirm
                }, null, 8, ["product-id", "onConfirm"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.stepList[_ctx.currentStepIndex] === _ctx.STEP_RENEW)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            (!_ctx.drawerMode)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/dashboard/overview"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { theme: "orange" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('subscribeDetails.deferRenew')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  theme: "orange",
                  onClick: _ctx.handleDeferRenew
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('subscribeDetails.deferRenew')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])),
            _createVNode(_component_el_button, {
              style: {"margin-left":"15px"},
              disabled: !_ctx.serviceListSelected.length,
              type: "primary",
              theme: "orange",
              onClick: _ctx.handleNextStep
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('subscribeDetails.confirmRenew')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ]))
      : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", null, [
            _createVNode(_component_OrderPrice, {
              "price-data": _ctx.viewModel.priceData
            }, null, 8, ["price-data"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_ctx.currentStepIndex !== 0)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  theme: "orange",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentStepIndex--))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('subscribeDetails.prevStep')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              style: {"margin-left":"15px"},
              type: "primary",
              theme: "orange",
              onClick: _ctx.handleNextStep
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('subscribeDetails.nextStep')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 512)), [
          [_vShow, _ctx.stepList[_ctx.currentStepIndex] !== _ctx.STEP_PAY]
        ]),
    _createVNode(_component_el_dialog, {
      "append-to-body": "",
      "modal-class": "cm-dashboard-dialog-fill",
      "z-index": _ctx.drawerMode ? 3001 : 1000,
      title: _ctx.$t('subscribeDetails.dialogTip'),
      modelValue: _ctx.dialogErrorPayVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogErrorPayVisible) = $event)),
      width: 470,
      "close-on-click-modal": false,
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PayError, {
          onPayCurrent: _ctx.payCurrent,
          onToHistory: _ctx.toHistory
        }, null, 8, ["onPayCurrent", "onToHistory"])
      ]),
      _: 1
    }, 8, ["z-index", "title", "modelValue"]),
    _createVNode(_component_PayDetails, {
      modelValue: _ctx.dialogOrderVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogOrderVisible) = $event)),
      "product-id": _ctx.payParams.product_id,
      "z-index": _ctx.drawerMode ? 3002 : 1000,
      "overlay-modal-class": "cm-dashboard-dialog-fill",
      "order-status": "",
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogOrderVisible = false))
    }, null, 8, ["modelValue", "product-id", "z-index"])
  ]))
}